import LottieView from 'react-native-web-lottie';

export default LottieView;
